import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, Button, Card, Flex, theme, Tooltip, Typography } from 'antd';
import cn from 'classnames';

import ProfileIcon from 'assets/images/icons/profile.svg?react';
import LogoutIcon from 'assets/images/menu/logout.svg?react';
import { commonApi } from 'shared/api/commonApi.ts';
import { EMainRoutes } from 'shared/typings';

import styles from './ShortInfo.module.scss';

interface IShortInfoProps extends HTMLAttributes<HTMLDivElement> {
	type?: 'menu' | 'profile';
}

export const ShortInfo: FC<IShortInfoProps> = ({ type = 'menu', ...props }) => {
	const { t } = useTranslation();
	const { data: appConfig } = commonApi.useGetAppConfigQuery();
	const {
		token: { colorFillTertiary },
	} = theme.useToken();

	if (type === 'menu') {
		const email = appConfig?.user?.email || '';

		return (
			<Tooltip title={email.length > 15 ? email : undefined}>
				<Typography.Text type="secondary" className={cn(styles.shortInfo, styles[type])}>
					{email.length > 15 ? `${email.slice(0, 2)}...${email.slice(email.length - 12, email.length)}` : email}
				</Typography.Text>
			</Tooltip>
		);
	}

	return (
		<Card {...props} styles={{ body: { padding: 20 } }} className={cn(styles.shortInfo, styles[type])}>
			<Flex vertical align="center" gap={16}>
				<Avatar size={80} icon={<ProfileIcon width={50} height={50} color={colorFillTertiary} />} />

				<Flex vertical align="center">
					<Typography.Text type="secondary">{t('Ваш аккаунт')}</Typography.Text>
					<Typography.Text strong style={{ fontSize: 16 }}>
						{appConfig?.user?.email}
					</Typography.Text>
					<Typography.Text type="secondary" copyable style={{ fontSize: 12 }}>
						{appConfig?.user?.user_id}
					</Typography.Text>
				</Flex>

				<Button icon={<LogoutIcon />} size="small" href={`/${EMainRoutes.ACCOUNT}/${EMainRoutes.LOG_OUT}/`}>
					{t('Выйти')}
				</Button>
			</Flex>
		</Card>
	);
};
